import React, { useEffect, useState } from "react";
import MainBg from "../components/Mainbg";
import Banner3 from "../assets/images/dasboard/banner3.png";
import Drawer from "react-modern-drawer";
import GymView from "./Sidebar/GymView";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshToken2,
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_MEAL_SELF_ENDPOINT } from "../config/ApisCollection";
import { useNavigate } from "react-router-dom";
import MealView from "./Sidebar/MealView";
import meal_not_generating from "../assets/images/loaders/meal_not_generating.png";
import NutritionSection from "../sections/NutritionSection";

const Mealdiet = () => {
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [mealChoosedData, setmealChoosedData] = useState(null);
  const [meal_data, set_meal_data] = useState([]);
  const [nutritionData, setNutritionData] = useState({});
  const [mealPlan_data, set_mealPlan_data] = useState(null);
  const [targeted_freq_data, set_targeted_freq_data] = useState([]);
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  let history = useNavigate();

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };

  const getMealData = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };

    await axios
      .get(GET_MEAL_SELF_ENDPOINT, request_body)
      .then((response) => {
        if (
          response.data &&
          response.data.message &&
          response.data.message == "meal not genereted yet"
        ) {
          set_mealPlan_data(response.data.message);
        } else {
          set_meal_data(response.data);
          set_mealPlan_data(response.data.mealPlan);
          set_mealPlan_data(response.data.mealPlan);
          set_targeted_freq_data(response.data.targetedFdietFrequency);

          let meal_data_1 = response.data;
          delete meal_data_1?.mealPlan;
          delete meal_data_1?.targetedFdietFrequency;

          setNutritionData(meal_data_1);
        }
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message === "token expired" &&
          secureLocalStorage.getItem("refreshToken")
        ) {
          dispatch(refreshToken2());
        } else if (error?.response?.data?.error?.message === "token expired") {
          secureLocalStorage.clear();
          history("/login");
        }
      });
  };

  useEffect(() => {
    getMealData();
    // set_mealPlan_data("meal not genereted yet");
    // console.log(meal_data);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Adds smooth scrolling
    });
  }, []);

  return (
    <>
      <MainBg>
        {mealPlan_data === "meal not genereted yet" ? (
          <>
            <img src={meal_not_generating} className="h-72 m-auto" />
            <h1 className="text-center text-xl font-bold mt-10">
              Your meal generation is under process.
            </h1>
          </>
        ) : (
          <></>
        )}
        {mealPlan_data !== "meal not genereted yet" &&
        mealPlan_data === null ? (
          <>
            <img src={meal_not_generating} className="h-72 m-auto" />
            <h1 className="text-center text-xl font-bold mt-10">
              Your meal is loading.
            </h1>
          </>
        ) : (
          <></>
        )}

        <div className="grid xl:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 grid-cols-1 sm:gap-20 py-20 mb-20">
          <div className="col-span-2 lg:px-10 px-2 sm:border-r-2 border-none">
            <div>
              {mealPlan_data !== "meal not genereted yet" &&
                mealPlan_data !== null &&
                Object.entries(mealPlan_data).length > 0 &&
                Object.entries(mealPlan_data)?.map(([key, cl_row], index) => (
                  <div key={index} className="mb-10">
                    <div className="">
                      {" "}
                      {/* mt-10 */}
                      <h1 className="font-bold">{key.toUpperCase()}</h1>
                    </div>
                    <div className="mt-2 grid xl:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2  gap-5 ">
                      {typeof cl_row == "object" &&
                        cl_row.map((wl_row, index) => (
                          <div
                            className="melasbox hover:bg-[#ffede0] cursor-pointer"
                            onClick={() => {
                              // setDrawerPopupOpen(true);
                              // setmealChoosedData(wl_row);
                              history("/mealdiet/meal-view", { state: wl_row });
                            }}
                            key={index}
                          >
                            <div>
                              <img
                                loading="lazy"
                                src={wl_row.thumbnail}
                                alt="meals1"
                                className="mealsimg h-[145px]"
                                height={145}
                                width={145}
                              />
                            </div>
                            <div className="melalin">
                              <div className="modesutit text-capitalize">
                                {wl_row.dietPreparation} min
                              </div>
                              <div className="tabetsbol text-capitalize text-[10px]">
                                {wl_row.dietTitle.slice(0, 30)}
                              </div>
                              <hr />
                              <div className="fastiweekboxtit">
                                {wl_row.dietCal + " Kcal"}{" "}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          {mealPlan_data !== "meal not genereted yet" &&
          mealPlan_data !== null &&
          Object.entries(mealPlan_data).length > 0 ? (
            <div className="flex sm:flex-row flex-col justify-start  lg:justify-center ">
              <div className="w-full">
                {mealPlan_data == "meal not genereted yet" ||
                mealPlan_data == null ? (
                  <></>
                ) : (
                  <>
                    <NutritionSection
                      nutritionData={nutritionData}
                      pageName={"eat"}
                    />

                    <div className="sm:w-full w-full mt-10">
                      <div className="fasweekdes p-0">
                        <div className="mode1">
                          <div className="tabroe">
                            <div className="modetit text-lg">Diet Type</div>
                          </div>
                        </div>
                      </div>

                      <div className="fasweekdes p-0">
                        {targeted_freq_data &&
                          targeted_freq_data.map((tp_row, index) =>
                            index < 5 ? (
                              <div
                                className="melasbox cursor-pointer h-[70px] w-[70px] m-0"
                                key={index}
                                onClick={() => {
                                  history(
                                    "/meal/explore/" + tp_row.categoryvalue
                                  );
                                }}
                              >
                                <div className="relative">
                                  <div className="flex justify-center">
                                    <img
                                      loading="lazy"
                                      src={tp_row.image}
                                      alt="meals1"
                                      className="h-[70px] w-[70px]"
                                    />
                                  </div>
                                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-center text-white">
                                    {tp_row.categorykey.toUpperCase()}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )
                          )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </MainBg>

      <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        {/* {console.log(mealChoosedData)} */}
        <MealView mealChoosedData={mealChoosedData} />
      </Drawer>
    </>
  );
};
export default Mealdiet;
